import React from 'react';
import { Box } from '../../../../../Box';
import { dataTableClassnames } from '../../../const/classNames';
import { Checkbox } from './Checkbox';

interface SelectRowHeadCellProps {
  dataTest?: string;
  className?: string;
  onToggle(value?: boolean): void;
  checkedAll: boolean | undefined;
  checkedSome: boolean | undefined;
}

export const SelectRowHeadCell: React.FC<SelectRowHeadCellProps> = ({
  className,
  dataTest,
  checkedAll,
  onToggle,
  checkedSome
}) => {
  return (
    <Box dataTest={dataTest} className={`${dataTableClassnames.table.cell.selectRow} ${className || ''}`}>
      <Checkbox checked={checkedAll} onToggle={() => onToggle(!checkedAll)} checkedSome={checkedSome} />
    </Box>
  );
};
